__webpack_require__.p = "/dxs-hackathon/";